import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import Footer from '../Component/Footer';
import logo from '../Image/logo.png';
import mpcst from '../Image/mpcst-logo.png';
import { useLanguage } from '../context/LanguageContext';
import Contact from '../Component/Contact';
import { Link } from 'react-router-dom'
import DesktopFooter from "../Component/Desktopfooter";

const Contactpage = () => {
    const { t } = useLanguage();
    return (
        <>
            <div className='text-Wrapper'>

                <div className="app-header-wrapper">
                    <div className='header-logo'>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className='header-text'>
                        <Typography variant='h4' sx={{ textTransform: 'uppercase' }}>{t('header_title')}</Typography>
                        <Typography variant='body1' sx={{ textTransform: 'uppercase' }}>{t('header_subtitle')}</Typography>
                      <div className='header-mainefooter'>
                                                 <Link to="/">{t('footer_home')}</Link>
                                                 <Link to="/about">{t('footer_about')}</Link>
                                                 <Link to="/More">{t('footer_more')}</Link>
                                         </div>
                    </div>
                    <div className='header-logo'>
                        <img src={mpcst} alt="logo" />
                    </div>
                </div>
                <Box>
                    <Toolbar>
                        <Contact />
                    </Toolbar>
                </Box>
            </div>
             <DesktopFooter/>
            <Footer />
        </>
    )
}

export default Contactpage